import { atom } from 'recoil';

export const SubHeaderState = atom({
  key: 'subHeaderState',
  default: {
    isDefaultScroll: false, // Set if the subHeader appears on scroll top 0 or not
    placement: null, // Set the position of the subHeader
    children: null,
  },
});
